/**
 * help keys
 */
const helpKeys = {
  helps: ["helps"],
  videos: ["helpVideos"],
};

export default helpKeys;
